import { Component, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { DsButtonVariants, Icons, IconStyles } from '@levelaccess/design-system';

export enum BannerType {
  success = 'success',
  error = 'error',
  info = 'info',
  warning = 'warning',
}

/**
 * TODO DS-186: get rid of this component once alternative is added to the
 * design system components
 */
@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  standalone: false,
})
export class BannerComponent {
  @Input()
  public visible: boolean = true;

  @Input()
  public message: string;

  @Input()
  public isHtml: boolean = false;

  @Input()
  public isRawHtml: boolean = false;

  @Input()
  public returnToUrl: string;

  public show(): void {
    this.visible = true;
  }

  public hide(): void {
    this.visible = false;
  }

  @Input()
  public type: BannerType;

  @Input()
  public icon: Icons;

  @Input()
  public iconStyle: IconStyles = IconStyles.Light;

  @Input()
  public closeable: boolean;

  @Output()
  public onClose: EventEmitter<void> = new EventEmitter();

  @Output()
  public onNavigateRequest$: EventEmitter<string> = new EventEmitter();

  constructor() {
    this.closeable = true;
    this.type = BannerType.success;
  }

  public closeBanner(): void {
    this.hide();
    this.onClose.emit();
  }

  @HostListener('click', ['$event'])
  protected handleRedirectLink(event: Event): void {
    if (event.target instanceof HTMLAnchorElement && this.returnToUrl) {
      event.preventDefault();
      this.onNavigateRequest$.emit(this.returnToUrl);
    }
  }

  protected readonly BannerType: typeof BannerType = BannerType;
  protected readonly Icons: typeof Icons = Icons;
  protected readonly DsButtonVariants: typeof DsButtonVariants = DsButtonVariants;
  protected readonly IconStyles: typeof IconStyles = IconStyles;
}
